// Mirrors the Firestore S03 gate. These are the approval fields written by
// AdminComplianceCenter, AdminCredentialManager and WorkerStateEngine.
// Registration approval and historical READY display flags are not approval.
export function hasApprovedWorkerReadiness(worker = {}) {
  return worker.status === "active" &&
    worker.onboardingStatus === "approved" &&
    ["approved", "ready"].includes(worker.complianceStatus) &&
    worker.active !== false &&
    (worker.disabled ?? false) === false &&
    (worker.archived ?? false) === false;
}
